// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"641292c3","419":"0f575f9a","563":"918ae73a","787":"28cb0dcd","942":"3f10588c"}[chunkId] + ".chunk.js";
};